export const WxPage = {
  main: '/pages/index/index',
  home: '/packageA/pages/webview/index',
  copy: '/packageA/pages/webview/copy',
  my: '/pages/my/my',
  h5: '/packageA/pages/webview/h5',
  login: '/packageA/pages/login/login',
  goodsDetails: '/packageB/pages/goodsDetail/goodsDetail',
  withDrawalDetail: '/packageC/pages/bank/withDrawalDetail',
  signIdCard: '/packageC/pages/bank/pages/signIdCard',
  signList: '/packageC/pages/bank/pages/signList'
}

// 路由白名单
export const WhitePathList = ['/login', '/bindSharer']

// projectRule
export const projectRules = {
  gmh: 'gmh',
  zhenmeilian: 'zhenmeilian',
  kaiXinJi: 'kaixinji',
  warmhome: 'warmhome',
  jiahuihui: 'jiahuihui',
  anxingtui: 'anxingtui',
  xygj: 'xinyuanguoji' //新源国际
}
